import { CampaignSortColumn } from 'types/campaign'
import { AgencySortColumn } from 'types/agency'
import { UserSortColumn } from 'types/user'
import { BroadSignGallerySortColumn } from 'types/broad-sign'
import { SortDirection } from 'types/various'

export interface UseTableFilterProps {
  setTableFilter: (id: Filter, filter: TableSort) => void
  getTableFilter: (id: Filter) => TableSort
}

export const useTableFilterPropsDefault: UseTableFilterProps = {
  setTableFilter: () => void {},
  getTableFilter: () => tableFilterDefault,
}

export type TableSort =
  | CampaignTableFilter
  | UserTableFilter
  | AgencyTableFilter
  | BroadSignGalleryTableFilter

const tableFilterDefault: TableSort = {
  column: CampaignSortColumn.NAME,
  direction: SortDirection.ASC,
}

interface CampaignTableFilter {
  column: CampaignSortColumn
  direction: SortDirection
}

interface UserTableFilter {
  column: UserSortColumn
  direction: SortDirection
}

interface AgencyTableFilter {
  column: AgencySortColumn
  direction: SortDirection
}

// the broadsign gallery tables keep their order in the component rather than in the store, they
// are here so that every column a table header can sort by has a home in this union
interface BroadSignGalleryTableFilter {
  column: BroadSignGallerySortColumn
  direction: SortDirection
}

const campaignTableFilterDefault: CampaignTableFilter = {
  column: CampaignSortColumn.START_DATE,
  direction: SortDirection.DESC,
}

const userTableFilterDefault: UserTableFilter = {
  column: UserSortColumn.AGENCY_NAME,
  direction: SortDirection.ASC,
}

const agencyTableFilterDefault: AgencyTableFilter = {
  column: AgencySortColumn.NAME,
  direction: SortDirection.ASC,
}

export interface FilterMeta {
  id: Filter
  filter: TableSort
}

export enum Filter {
  CAMPAIGN = 'campaign',
  VOOH_CAMPAIGN = 'voohCampaign',
  USER = 'user',
  AGENCY = 'agency',
}

export const filtersDefault: FilterMeta[] = [
  {
    id: Filter.CAMPAIGN,
    filter: campaignTableFilterDefault,
  },
  {
    id: Filter.VOOH_CAMPAIGN,
    filter: campaignTableFilterDefault,
  },
  {
    id: Filter.USER,
    filter: userTableFilterDefault,
  },
  {
    id: Filter.AGENCY,
    filter: agencyTableFilterDefault,
  },
]
